import { render, staticRenderFns } from "./LocalisationAssetWidgetComponent.vue?vue&type=template&id=24c5300b&"
import script from "./LocalisationAssetWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./LocalisationAssetWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports